import React, {useEffect, useState} from 'react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import artworksData from "../../data/artworks.json";
import { Link } from "react-router-dom";
import { useTranslation } from "../../context/TranslationsProvider";
import axios from "axios";

interface Product {
    id: number;
    product_title_lv: string;
    product_title_eng: string;
    product_title_ru: string;
    product_desc_lv: string;
    product_desc_eng: string;
    product_desc_ru: string;
    dimensions: string;
    price: string;
    main_image: string | null;
    created_at: string;
    is_sold: boolean;
}

const Main = () => {

    const [data, setData] = useState<Product[]>([]);

    const [loader, setLoader] = useState<boolean>(true)

    const { translate, language } = useTranslation();

    const API_URL = `${process.env.REACT_APP_API_URL}`


    const fetchData = () => {
        axios.get(`${API_URL}/products`, {withCredentials: true})
            .then(response => {
                setData(response.data)
                setLoader(false)
            })
            .catch(errors => {
                setLoader(false)
            })
    }

    useEffect(()=>{
        fetchData()
    }, [])

    return (
        <div className="flex justify-center flex-col">
            <Header />
            <div className="h-[80vh] flex bg-black justify-center">
                <img
                    className="object-cover relative brightness-75"
                    src={process.env.PUBLIC_URL + '/assets/images/hero_image.jpg'}
                    alt=""
                />
                <div className="absolute absolute-center flex flex-col justify-center items-center">
                    <h1 className="text-4xl md:text-5xl font-semibold text-center text-orange-100">
                        {translate("hero_title")}
                    </h1>
                    <Link to="/all-paintings">
                        <button className="main-btn mt-4">
                            {translate("hero_button")}
                        </button>
                    </Link>
                </div>
            </div>
            <div className="flex flex-col items-center bg-[#f4f1ea] p-10 min-h-screen">
                <div className="container max-w-6xl flex flex-col">
                    <div className="flex justify-between flex-col md:flex-row md:items-center mb-8 border-b border-gray-500 pb-2">
                        <h1 className="font-bold text-lg text-gray-800">{translate("product_title")}</h1>
                        <Link className="flex space-x-2" to="/all-paintings">
                            <button className="text-gray-800 text-sm">{translate("product_view_more_button")}</button>
                            <svg className="rotate-45 transition h-7 w-7 fill-gray-800" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <g id="🔍-Product-Icons" stroke="none" strokeWidth="1" fillRule="evenodd">
                                        <g id="ic_fluent_arrow_up_right_24_regular" fillRule="nonzero">
                                            <path d="M12.748109,3.00129623 L20.3018618,3.00180934 L20.4020922,3.01572723 L20.4020922,3.01572723 L20.5009384,3.04332427 L20.5009384,3.04332427 L20.5612467,3.06889413 L20.5612467,3.06889413 C20.6404539,3.1037255 20.7146881,3.15440738 20.7799038,3.21960789 L20.8206178,3.2636488 L20.8206178,3.2636488 L20.8811543,3.34512786 L20.8811543,3.34512786 L20.9183431,3.41015101 L20.9183431,3.41015101 L20.9570257,3.50046614 L20.9570257,3.50046614 L20.9762122,3.56459327 L20.9762122,3.56459327 L20.9897917,3.6285349 L20.9897917,3.6285349 L20.9991061,3.72173042 L20.9991061,3.72173042 L20.9996358,11.2551867 C20.9996358,11.6694002 20.6638494,12.0051867 20.2496358,12.0051867 C19.86994,12.0051867 19.5561448,11.7230328 19.5064824,11.3569572 L19.4996358,11.2551867 L19.4991881,5.55929623 L4.27958018,20.7845763 C4.01334477,21.050874 3.59668392,21.0751288 3.30304694,20.8573087 L3.21892002,20.7847004 C2.95262231,20.518465 2.92836752,20.1018041 3.14618764,19.8081671 L3.21879595,19.7240402 L18.4381881,4.50029623 L12.748109,4.50129623 C12.3684132,4.50129623 12.054618,4.21914235 12.0049556,3.85306678 L11.998109,3.75129623 C11.998109,3.37160046 12.2802629,3.05780527 12.6463384,3.00814284 L12.748109,3.00129623"> </path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </Link>
                    </div>
                        {loader ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-pulse">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <div key={index} className="animate-pulse">
                                        <div className="w-full h-64 bg-zinc-300"></div>
                                        <div className="h-6 bg-zinc-300  mt-4 w-3/4"></div>
                                        <div className="h-4 bg-zinc-300 mt-2 w-1/2"></div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {data && Array.isArray(data) && data.map((item: Product, index: number) => (
                                    <Link
                                        to={`/painting/${item.product_title_eng}`}
                                        key={index}
                                        className="block group"
                                    >
                                        {item.main_image && (
                                            <img
                                                src={item.main_image}
                                                alt={item[`product_title_${language}` as keyof Product] as string}
                                                className="w-full h-auto group-hover:opacity-75 transition"
                                            />
                                        )}
                                        <h2 className="text-lg font-semibold mt-4 text-gray-800">
                                            {item[`product_title_${language}` as keyof Product]}
                                        </h2>
                                        <p className="text-sm text-gray-700">
                                            {item.is_sold ? item.price + " €" : translate("sold")} | {item.dimensions} cm
                                        </p>
                                    </Link>
                                ))}
                            </div>
                        )}
                        {!loader && data.length === 0 && (
                            <h1 className="self-center text-gray-800 py-6">{translate("product_empty_error")}</h1>
                        )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Main;
